import {connect} from "react-redux"
import {IncomingHttpHeaders} from "http"
import {State} from "../../ducks"
import {SupportedRegionTypes} from "../../models/regions"
import {formatCdnPathWithVariant} from "../../utils/getCdnUrl"
import {
    REALM_HEADER,
    TABBED_NAVIGATION_COOKIE_TABBED_VALUE,
    TABBED_NAVIGATION_COOKIE_DEFAULT_VALUE,
} from "../../config/constants"

export const mapStateToProps = (state: State) => {
    const brand: any = state.data?.regions.find(region => region.type === SupportedRegionTypes.Brand)
    const {siteUrl, headers} = state.request
    let tabbedNavHeader = ((headers && headers["x-next-tabbed-navigation"]) || "") as string
    const {icon, narrowModeIcon, wideModeIcon, accessibilityText, tooltip, url, name} = brand.elements[0]
    const {variant, iconsVersionPath, tabbedNavigationEnabled} = state.settings
    const realm = (state.request.headers as IncomingHttpHeaders)[REALM_HEADER] as string

    if (
        tabbedNavigationEnabled &&
        ![TABBED_NAVIGATION_COOKIE_DEFAULT_VALUE, TABBED_NAVIGATION_COOKIE_TABBED_VALUE].includes(tabbedNavHeader)
    ) {
        tabbedNavHeader = TABBED_NAVIGATION_COOKIE_DEFAULT_VALUE
    }

    return {
        icon: formatCdnPathWithVariant(icon as string, realm, variant, iconsVersionPath),
        wideModeIcon: formatCdnPathWithVariant(wideModeIcon as string, realm, variant, iconsVersionPath),
        narrowModeIcon: formatCdnPathWithVariant(narrowModeIcon as string, realm, variant, iconsVersionPath),
        accessibilityText: accessibilityText as string,
        tooltip: tooltip as string,
        url: `${siteUrl}${url}`,
        name,
        isTabbedNavSetToDefault: tabbedNavHeader === TABBED_NAVIGATION_COOKIE_DEFAULT_VALUE,
        templating: state.template,
    }
}

export default connect(mapStateToProps)
